import { Plus } from 'lucide-react';
import { TopbarSearch } from '@/components/ui/TopbarSearch';
import { AuthButton } from '@/core/permissions/AuthButton';
import type { RoleFilters } from '../types/rolesList.types';

interface RolesToolbarProps {
  filters: RoleFilters;
  onFiltersChange: (filters: RoleFilters) => void;
  onAdd: () => void;
}

export function RolesToolbar({ filters, onFiltersChange, onAdd }: RolesToolbarProps) {
  return (
    <div className="rounded-md border border-slate-100 bg-white p-3 shadow-sm flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-row items-center gap-2 flex-1">
        <div className="flex-1 min-w-0">
          <TopbarSearch
            value={filters.query}
            onChange={(query) => onFiltersChange({ ...filters, query })}
            placeholder="Tìm vai trò, mã hoặc mô tả"
          />
        </div>
      </div>
      <div className="flex flex-row items-center gap-2 overflow-x-auto">
        <select
          value={filters.status}
          onChange={(event) => onFiltersChange({ ...filters, status: event.target.value as RoleFilters['status'] })}
          className="h-10 shrink-0 rounded-md border border-slate-200 bg-white px-2 text-xs text-slate-700 outline-none w-[110px] sm:w-[140px]"
        >
          <option value="all">Tất cả trạng thái</option>
          <option value="active">Đang dùng</option>
          <option value="inactive">Tạm ngưng</option>
        </select>
        <select
          value={filters.kind}
          onChange={(event) => onFiltersChange({ ...filters, kind: event.target.value as RoleFilters['kind'] })}
          className="h-10 shrink-0 rounded-md border border-slate-200 bg-white px-2 text-xs text-slate-700 outline-none w-[110px] sm:w-[120px]"
        >
          <option value="all">Tất cả loại</option>
          <option value="system">Hệ thống</option>
          <option value="custom">Tùy chỉnh</option>
        </select>
        <AuthButton
          module="roles"
          action="create"
          behavior="disable"
          permissionReason="Bạn không có quyền thêm vai trò"
          onClick={onAdd}
          className="flex h-10 shrink-0 items-center justify-center gap-2 rounded-md bg-emerald-600 px-4 text-xs font-semibold text-white shadow-sm whitespace-nowrap"
        >
          <Plus className="h-4 w-4" />
          <span>Thêm vai trò</span>
        </AuthButton>
      </div>
    </div>
  );
}
